// extracted by mini-css-extract-plugin
export default {"membertablecontainer":"PermissionMemberTable_membertablecontainer__Xpqrb","membertable":"PermissionMemberTable_membertable__9mbQs"};